<script setup lang="ts">
import { QCheckbox, QItem } from 'quasar'
import { computed } from 'vue'
import { Color } from '@previo/codebooks'
import { PMaxLines } from '../typography/types'
import PTextFormBody from '../typography/form/PTextFormBody.vue'
import PSpace from '../space/PSpace.vue'
import { PSpaceSize } from '../space/types'
import PIcon from '../icon/PIcon.vue'
import PTooltip from '../tooltip/PTooltip.vue'
import { PTooltipAnchor } from '../tooltip/types'

type Props = {
  label?: null | string
  maxLines?: null | PMaxLines
  tooltip?: null | string
  disable?: boolean
  errorMessage?: null | string
  cy: string
}

const model = defineModel<boolean | null>({ default: false })

const props = withDefaults(defineProps<Props>(), {
  maxLines: null,
  tooltip: null,
  disable: false,
})

const color = computed<Color.NEGATIVE | Color.PRIMARY | Color.GREY_400>(() => {
  if (props.disable) {
    return Color.GREY_400
  }

  return props.errorMessage ? Color.NEGATIVE : Color.PRIMARY
})
</script>

<template>
  <div class="ds-p-checkbox p-flex">
    <q-item tag="label" manual-focus>
      <q-checkbox
        v-model="model"
        dense
        size="48px"
        :disable="disable"
        :color="color"
        :keep-color="!!errorMessage"
        checked-icon="fa-light fa-square-check"
        unchecked-icon="fa-light fa-square"
        indeterminate-icon="fa-light fa-square-minus"
        :data-cy="cy"
      >
        <template #default>
          <div class="p-display-flex">
            <div>
              <slot name="default">
                <div class="p-flex p-no-wrap">
                  <p-text-form-body :text="label" :max-lines="maxLines" />
                </div>
              </slot>
            </div>
          </div>
        </template>
      </q-checkbox>
    </q-item>

    <template v-if="tooltip">
      <p-space :mobile="PSpaceSize.XS" />
      <p-tooltip
        :text="tooltip"
        :anchor="PTooltipAnchor.TOP_MIDDLE"
        :self="PTooltipAnchor.BOTTOM_MIDDLE"
      >
        <p-icon icon="question-circle" />
      </p-tooltip>
    </template>
  </div>
</template>
